"use strict";

require("../../style/index.less");

require("./index.less");


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/drawer/style/index.js
// module id = 1185
// module chunks = 1